import { THALAMOS_ADMIN_ROLE } from "../types/thalamos.js";
import type { SessionContext } from "../types/user.js";
import { isThalamosAdminMembership } from "./isThalamosAdminMembership.js";

/**
 * Whether a session acts in Thalamos administration through `thalamos_admin`
 * held at the Thalamos organisation.
 */
export const isThalamosAdministrationSessionContext = (
  context: SessionContext | null | undefined,
): boolean =>
  context?.kind === "thalamos_administration" &&
  context.roles.includes(THALAMOS_ADMIN_ROLE) &&
  isThalamosAdminMembership({
    organisationId: context.organisationId,
    role: THALAMOS_ADMIN_ROLE,
  });
